import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { DemoModeService } from '../services/demo-mode.service';

export const withCredentialsInterceptor: HttpInterceptorFn = (req, next) => {
  const demoModeService = inject(DemoModeService);

  // In demo mode, all requests (including GraphQL) use cookie-based identity
  // In normal mode, GraphQL uses Bearer token auth so skip withCredentials
  if (req.url.includes('/graphql') && !demoModeService.isDemo()) {
    return next(req);
  }

  // Clone the request and add withCredentials for other requests
  const authReq = req.clone({
    withCredentials: true
  });

  return next(authReq);
};
